import { useWatchProgressQuery } from '@nx/state/desktop';

import { InstanceCardHeader, InstanceCardWrapper } from '../../components/instance-card-wrappers';
import { ProgressStep } from '../../components/progress-step';
import { InstanceInfo } from './instance-info';
import { InstanceStatusLabelLoading } from './instance-status-label';

export const useDbmsInstallProgressEvents = () => {
  const { data: progress, error } = useWatchProgressQuery({ operation: 'dbmsInstall' });
  return {
    events: Object.entries(progress?.entities ?? {})
      .filter(([key]) => key.startsWith('dbmsInstall') && key !== 'dbmsInstall')
      .map(([key, value]) => ({ id: key, events: value.events })),
    error,
  };
};

const getNameAndVersionFromId = (id: string) => {
  const [name = '', version = ''] = id.replace('dbmsInstall', '').split('|');
  return { name, version };
};

export const CreateInstanceProgress = () => {
  const { events: progress } = useDbmsInstallProgressEvents();

  if (progress.length === 0) {
    return null;
  }

  return (
    <>
      {progress.map((event) => {
        if (Object.keys(event.events).length === 0) {
          return null;
        }

        const { name, version } = getNameAndVersionFromId(event.id);

        return (
          <InstanceCardWrapper key={event.id}>
            <InstanceCardHeader instanceName={name} />
            <InstanceStatusLabelLoading label="Installing" />
            <InstanceInfo instance={{ version }} />
            <div className="flex flex-col gap-2" key={event.id}>
              {Object.entries(event.events).map(([message, step]) => (
                <ProgressStep step={step} key={message} />
              ))}
            </div>
          </InstanceCardWrapper>
        );
      })}
    </>
  );
};
